import React, { useState } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import EditNoteIcon from '@mui/icons-material/EditNote';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import MainContent from '../components/MainContent';
import UploadEntries from '../components/UploadEntries';
import PdfOrganizer from '../components/PdfOrganizer';
import { BRAND } from '../theme';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
  /** The workspace manages its own padding and height */
  flush?: boolean;
}

const TabPanel: React.FC<TabPanelProps> = ({ children, value, index, flush }) => (
  <div
    role="tabpanel"
    hidden={value !== index}
    id={`data-entry-tabpanel-${index}`}
    aria-labelledby={`data-entry-tab-${index}`}
  >
    {value === index && <Box sx={{ p: flush ? 0 : { xs: 1.5, sm: 2, md: 3 } }}>{children}</Box>}
  </div>
);

interface DataEntryPageProps {
  onFormSubmit: (entries: any[]) => Promise<Blob>;
}

const DataEntryPage: React.FC<DataEntryPageProps> = ({ onFormSubmit }) => {
  const [tabValue, setTabValue] = useState(0);

  return (
    <Box sx={{ width: '100%' }}>
      <Box
        sx={{
          borderBottom: `1px solid ${BRAND.border}`,
          backgroundColor: 'background.paper',
          px: { xs: 1, md: 2 }
        }}
      >
        <Tabs
          value={tabValue}
          onChange={(_, newValue) => setTabValue(newValue)}
          aria-label="data entry tabs"
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab
            icon={<EditNoteIcon fontSize="small" />}
            iconPosition="start"
            label="New Entries"
            id="data-entry-tab-0"
            sx={{ textTransform: 'none', fontWeight: 600, minHeight: 48 }}
          />
          <Tab
            icon={<PictureAsPdfIcon fontSize="small" />}
            iconPosition="start"
            label="Organize and Edit PDF"
            id="data-entry-tab-1"
            sx={{ textTransform: 'none', fontWeight: 600, minHeight: 48 }}
          />
          <Tab
            icon={<CloudUploadIcon fontSize="small" />}
            iconPosition="start"
            label="Upload Entries"
            id="data-entry-tab-2"
            sx={{ textTransform: 'none', fontWeight: 600, minHeight: 48 }}
          />
        </Tabs>
      </Box>

      <TabPanel value={tabValue} index={0} flush>
        <MainContent onFormSubmit={onFormSubmit} />
      </TabPanel>
      <TabPanel value={tabValue} index={1}>
        <PdfOrganizer />
      </TabPanel>
      <TabPanel value={tabValue} index={2}>
        <UploadEntries />
      </TabPanel>
    </Box>
  );
};

export default DataEntryPage;
